import { croppingTextLimit } from 'shared/constants';

export function cropText(value: string, limit: number = croppingTextLimit): string {
  return value.length > limit ? `${value.slice(0, limit)}...` : value;
}
